export class NameValuePair {
    public name: string;
    public value: any;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/receipt/name-value-pair.model.ts